export enum SupportChatLanguage {
    EN = 'en',
    CS = 'cs',
    RO = 'ro',
    DE = 'de',
    HR = 'hr',
}

export enum SupportChatExternalAuthorizationMethod {
    PROPERTY = 'property',
    OIDC = 'oidc',
    TOKEN_EXCHANGE = 'tokenExchange',
    TOKEN_EXCHANGE_INVALIDATION_POST = 'tokenExchangeInvalidationPost',
}

export interface SupportChatFeatureConfig {
    channelId: string;
    externalAuthorizationMethod: SupportChatExternalAuthorizationMethod;
    externalAuthorizationTokenExchangeKeepAccessTokenInCookie: boolean;
    externalSupportChat: boolean;
    fallbackLanguage: SupportChatLanguage;
    languagePackage: string;
    showClientIdentity: boolean;
    supportedLanguages: SupportChatLanguage[];
    useInvalidationWhenSessionExpired: boolean;
    displayChatStatus: boolean;
    useAuthenticatedFlag: boolean;
    proactiveChatAutoHideInput: boolean;
    proactiveChatChannelId: string;
}
